<template>
  <Breadcrumbs main="Paramétricas" title="Ambientes" />
  <div class="container-fluid">
    <div class="row project-cards">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body d-flex justify-content-start">
            <SearchInput
              v-model="searchQuery"
              placeholder="Buscar por nombre..."
            />
          </div>
        </div>
      </div>
      <TopMenu @reload-list-place="reloadList()" />
      <Table ref="tableRef" :search="searchQuery" />
    </div>
  </div>
</template>

<script>
import TopMenu from "./components/TopMenu.vue";
import Table from "./components/Table.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  name: "place",
  components: {
    TopMenu,
    Table,
    SearchInput,
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    reloadList() {
      this.$refs.tableRef.loadItems();
    },
  },
};
</script>
